import React, { ReactNode } from 'react';

import styles from './menu.module.css';
import classNames from 'classnames';

type Props = {
	selected?: boolean;
	className?: string;
	children: ReactNode;
};

/**
 * MenuItem Component
 */
export const MenuItem: React.FC<Props> = ({
	className = '',
	selected = false,
	children,
}) => {
	return (
		<li
			className={classNames(styles.item, className, {
				[styles.selected]: selected,
			})}
		>
			{children}
		</li>
	);
};
